import { render, staticRenderFns } from "./FormValidationMultiple.vue?vue&type=template&id=6b0fae6a&"
import script from "./FormValidationMultiple.vue?vue&type=script&lang=js&"
export * from "./FormValidationMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports